/* tslint:disable */

/**
 */
export class SizingOptimumData {
    id?: number;
    equipName?: string;
    dhp?: number;
    conso?: number;
    dhpMax?: number;
    consoMax?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/sizing-optimum-data.ts